import { FC } from "react";
import { twMerge } from "tailwind-merge";
import Link from "next/link";
import LandingBody from "./landing-body";
import { CARD_VARIANT, ILandingCard } from "@shared/components/card/types";
import CardImage from "@shared/components/card/card-image";
import { FAVORITE_TYPE } from "enums/favorite-type";

const LandingCard: FC<ILandingCard> = ({
  svg_image,
  png_image,
  type,
  slug,
  variant,
  imageWidth,
  isFavorite,
  id,
  href,
  title,
  showDetail = true,
  courseCount,
  studentCount,
  noBorder,
  hugElement,
  title_short,
}) => {
  const CardContent = (
    <>
      <CardImage
        svg_image={svg_image}
        png_image={png_image}
        type={type}
        slug={slug}
        variant={variant}
        isFavorite={isFavorite}
        id={id}
        width={imageWidth}
        title={title_short || title}
        favoriteType={FAVORITE_TYPE.HOW_TO_LEARN}
      />

      <Link href={href} prefetch={false}>
        {Boolean(showDetail) && (
          <LandingBody
            courseCount={courseCount}
            studentCount={studentCount}
            href={href}
            title={title_short || title}
            hugElement={hugElement || false}
          />
        )}
      </Link>
    </>
  );

  return (
    <div
      className={twMerge(
        variant === CARD_VARIANT.GRID ? "flex-col" : "flex-row",
        "border-fds-cart hover:shadow-brand-md sm:p-4     py-2  flex  pr-2.5   pl-3.5   w-full",
        noBorder ? "border-b" : "border rounded-8"
      )}
    >
      {CardContent}
    </div>
  );
};
export default LandingCard;
